export default __webpack_public_path__ + "afd448ad781526a30cb9296d57c0c473.png";